const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  appId: state => state.user.appId,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userId: state => state.user.userId,
  permission_routes: state => state.permission.routes
}
export default getters
